import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  clientId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useUpdateDefaultBillTo = ({
  clientId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate } = useMutation({
    mutationFn: ({
      defaultBillToClientId,
    }: {
      defaultBillToClientId?: string;
    }) => {
      return ClientsClient.updateDefaultBillTo({
        clientId,
        defaultBillToClientId,
      });
    },
    onSuccess,
    onError,
  });

  return {
    updateDefaultBillTo: mutate,
  };
};
